var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgQuoteRightinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 150,
    viewBox: "0 0 220 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M125.376 49.194c0 11.29 3.417 20.967 10.251 29.032 6.834 8.602 15.508 14.247 26.022 16.935-1.052 6.99-3.68 14.248-7.886 21.774-4.731 8.065-9.725 14.517-14.982 19.355L154.552 150C198.184 120.43 220 86.828 220 49.194c0-13.979-4.468-25.807-13.405-35.484C197.133 4.57 185.83 0 172.688 0c-13.142 0-24.181 4.839-33.118 14.516-9.462 9.678-14.194 21.237-14.194 34.678zM0 49.194c0 11.29 3.417 20.967 10.25 29.032 6.835 8.602 15.509 14.247 26.022 16.935-1.577 7.527-4.468 15.054-8.673 22.581-4.732 7.527-9.726 13.71-14.982 18.548L29.175 150c44.157-30.645 66.236-64.247 66.236-100.806 0-13.441-4.731-25-14.193-34.678C71.756 4.84 60.454 0 47.312 0 34.695 0 23.656 4.839 14.194 14.516 4.73 24.194 0 35.753 0 49.194z",
    fill: "#5945FF"
  })));
}

export default SvgQuoteRightinline;